import * as v from "valibot";

import { rpcContract } from "../rpc";

export const saveProfileRpcContract = rpcContract({
  name: "saveProfile",
  paramsSchema: v.object({
    handle: v.optional(
      v.pipe(
        v.string(),
        v.minLength(3, "Handle must be at least 3 characters"),
        v.regex(
          /^[a-z0-9_\-.]+$/,
          "Handle can only contain lowercase letters, numbers, underscores, hyphens, and dots",
        ),
      ),
    ),
    bio: v.optional(v.string()),
    selectedThemeId: v.optional(v.string()),
    socialLinks: v.optional(v.array(v.string())),
    profileImageFileId: v.optional(v.string()),
    profileCoverFileId: v.optional(v.string()),
    customColors: v.optional(
      v.object({
        primary: v.pipe(v.string(), v.regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/)),
        secondary: v.pipe(v.string(), v.regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/)),
      }),
    ),
  }),
  resultSchema: v.undefined(),
});

export type SaveProfileParams = v.InferOutput<(typeof saveProfileRpcContract)["paramsSchema"]>;

export type SaveProfileResult = v.InferOutput<(typeof saveProfileRpcContract)["resultSchema"]>;
